import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=01f72bb6&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=ts"
export * from "./Sign.vue?vue&type=script&lang=ts"
import style0 from "./Sign.vue?vue&type=style&index=0&id=01f72bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f72bb6",
  null
  
)

export default component.exports